import React from 'react';
import { Box, makeStyles, Theme } from '@material-ui/core';
import Footer from 'components/Footer';
import AccountExpired from 'components/AccountExpired';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/rootReducer';
import ProtectedRoutes from 'layouts/ProtectedRoutes';
import { ACCOUNT_STATUS } from 'redux/checkInSlice';

const MainLayout = () => {
  const classes = desktopStyles();
  const accountStatus = useSelector((state: RootState) => state.checkIn.account.status);
  return (
    <Box component="div" className={classes.container}>
      {/* Allowing All user with status PAID, FREEMIUM or TRIAL except UNAUTHORIZED user. */}
      {accountStatus && [ACCOUNT_STATUS.UNAUTHORIZED as string].includes(accountStatus.toLowerCase()) ? (
        <AccountExpired />
      ) : (
        <ProtectedRoutes />
      )}
      <Footer />
    </Box>
  );
};

const desktopStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    minHeight: 300,
    padding: `${theme.spacing(1)}px ${theme.spacing(3)}px 0 ${theme.spacing(3)}px`,
    width: '100%',
    justifyContent: 'space-between',
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      height: 'calc(100vh + 50px)'
    },
    '@supports (-ms-accelerator:true)': {
      padding: `${theme.spacing(1)}px`
    },
    // Legacy Edge 16+
    '@supports (-ms-ime-align:auto)': {
      padding: `${theme.spacing(1)}px`
    }
  }
}));

export default MainLayout;
